import { render, staticRenderFns } from "./landInfo.vue?vue&type=template&id=04e8a220&scoped=true&"
import script from "./landInfo.vue?vue&type=script&lang=js&"
export * from "./landInfo.vue?vue&type=script&lang=js&"
import style0 from "./landInfo.vue?vue&type=style&index=0&id=04e8a220&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04e8a220",
  null
  
)

export default component.exports